<template>
    <el-dialog
        title="开票确认"
        :visible.sync="invoiceConfirmationDialog"
        width="800px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        custom-class="custom-form-dialog custom_invoice_dialog"
    >
        <div>
            <div class="page_little_title">订单信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="关联订单">
                            <div>
                                <el-link
                                    type="primary"
                                    v-text="invoiceDetails.order_info.order_no"
                                    :underline="false"
                                    @click="handleClickOrderDetail"
                                >
                                </el-link>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户联系人">
                            <div
                                v-text="
                                    invoiceDetails.order_info.contact_info &&
                                    invoiceDetails.order_info.contact_info.name
                                "
                            ></div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="page_little_title">订单金额信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="订单总金额">
                            <div v-text="invoiceDetails.order_info.total_price"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="已回款金额">
                            <div v-text="invoiceDetails.order_info.total_repay_price"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="待回款金额">
                            <div v-text="invoiceDetails.order_info.no_repay_price"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实际回款金额">
                            <div v-text="invoiceDetails.order_info.repay_price"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="page_little_title">开票申请信息</div>
            <el-form label-position="top" size="small">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="开票公司">
                            <div v-text="invoiceDetails.invoice_info.invoice_company_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发票类型">
                            <div v-text="invoiceDetails.invoice_info.invoice_type_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 1 ||
                            invoiceDetails.invoice_info.invoice_type === 2
                        "
                        :span="12"
                    >
                        <el-form-item label="电子发票提供方式">
                            <div v-text="invoiceDetails.invoice_info.invoice_method_name || '--'"></div>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 1 ||
                            invoiceDetails.invoice_info.invoice_type === 2
                        "
                        :span="12"
                    >
                        <el-form-item label="电子收票邮箱">
                            <div v-text="invoiceDetails.invoice_info.invoice_email || '--'"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="本次开票金额">
                            <div v-text="invoiceDetails.invoice_info.invoice_amount"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="开票对象">
                            <div v-text="invoiceDetails.invoice_info.invoice_title_type_name"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="开票信息">
                            <div class="text_bg" v-html="invoiceDetails.invoice_info.invoice_info"></div>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 3 ||
                            invoiceDetails.invoice_info.invoice_type === 4
                        "
                        :span="12"
                    >
                        <el-form-item label="收货人" prop="receive_name">
                            <span
                                v-text="
                                    invoiceDetails.invoice_info.receive_name
                                        ? invoiceDetails.invoice_info.receive_name
                                        : '--'
                                "
                            ></span>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 3 ||
                            invoiceDetails.invoice_info.invoice_type === 4
                        "
                        :span="12"
                    >
                        <el-form-item label="收货人电话" prop="receive_phone">
                            <span
                                v-text="
                                    invoiceDetails.invoice_info.receive_phone
                                        ? invoiceDetails.invoice_info.receive_phone
                                        : '--'
                                "
                            ></span>
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            invoiceDetails.invoice_info.invoice_type === 3 ||
                            invoiceDetails.invoice_info.invoice_type === 4
                        "
                        :span="24"
                    >
                        <el-form-item label="收货地址" prop="receive_addr">
                            <span
                                v-text="
                                    invoiceDetails.invoice_info.receive_addr
                                        ? invoiceDetails.invoice_info.receive_addr
                                        : '--'
                                "
                            ></span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <div class="text_bg" v-text="invoiceDetails.invoice_info.remark"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="附件">
                            <ul
                                class="voucher_list voucher_detail_list"
                                v-if="
                                    invoiceDetails.invoice_info.attachments &&
                                    invoiceDetails.invoice_info.attachments.length
                                "
                            >
                                <li
                                    :key="index"
                                    class="voucher_item"
                                    v-for="(item, index) in invoiceDetails.invoice_info.attachments"
                                >
                                    <el-image
                                        :preview-src-list="
                                            invoiceDetails.invoice_info.attachments.map((file) => file.file_path)
                                        "
                                        :src="item.file_path"
                                        alt=""
                                    >
                                    </el-image>
                                </li>
                            </ul>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="page_little_title">发票号码信息</div>
            <el-form
                ref="invoiceForm"
                :rules="invoiceFormRules"
                :model="invoiceForm"
                label-position="top"
                v-loading="formLoading"
            >
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="发票号码" prop="invoice_number">
                            <el-input placeholder="请输入发票号码" v-model="invoiceForm.invoice_number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="page_little_title">其他信息</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="财务备注" prop="finance_remark">
                            <el-input
                                :rows="4"
                                maxlength="200"
                                placeholder="请输入备注信息"
                                type="textarea"
                                v-model="invoiceForm.finance_remark"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="附件" prop="finance_attachments">
                    <div class="file_upload_wrap">
                        <div
                            v-if="invoiceForm.finance_attachments && invoiceForm.finance_attachments.length === 0"
                            class="file_outer_wrap"
                        >
                            <img
                                alt=""
                                src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                                width="36"
                            />
                            <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                            <p class="file_type_hint">支持.rar .zip .doc .docx .pdf .jpg...</p>
                            <input class="upload_input" multiple type="file" @change="handleUploadFileChange($event)" />
                        </div>
                        <ul v-else class="upload_file_list">
                            <li
                                v-for="(file, file_idx) in invoiceForm.finance_attachments"
                                :key="file_idx"
                                class="upload_file_item"
                            >
                                <div class="file_left_wrap">
                                    <img
                                        alt=""
                                        class="file_img"
                                        src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                    />
                                    <div class="file_info_wrap">
                                        <p class="file_name" v-text="file.file_name"></p>
                                        <p class="file_size" v-text="file.file_size"></p>
                                    </div>
                                </div>
                                <div class="file_right_wrap">
                                    <el-tooltip content="预览" effect="dark" placement="top">
                                        <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                            <i class="iconfont icon-yanjing"></i>
                                        </span>
                                    </el-tooltip>
                                    <span class="line"></span>
                                    <el-tooltip content="删除" effect="dark" placement="top">
                                        <span
                                            class="handle_icon_wrap handle_icon_danger_wrap"
                                            @click="invoiceForm.finance_attachments.splice(file_idx, 1)"
                                        >
                                            <i class="iconfont icon-shanchu1"></i>
                                        </span>
                                    </el-tooltip>
                                </div>
                            </li>
                            <li class="upload_file_btn_wrap">
                                <i class="el-icon-plus"></i>
                                <span>添加附件</span>
                                <input
                                    class="upload_input"
                                    multiple
                                    type="file"
                                    @change="handleUploadFileChange($event)"
                                />
                            </li>
                        </ul>
                    </div>
                </el-form-item>
            </el-form>
            <el-image
                :preview-src-list="previewImgList"
                :src="previewImgSrc"
                ref="preview_img"
                style="display: none"
            ></el-image>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">提交</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { InvoiceDetail, InvoiceConfirm } from "@/api";
import { formatFileSize } from "@/utils";
import { uploadImg } from "@/utils/uploadOss";
export default {
    name: "InvoiceConfirmation",
    props: {
        invoiceConfirmationDialog: {
            type: Boolean,
            default: () => false,
        },
        invoice_no: "", // 开票编号
    },
    data() {
        return {
            invoiceDetails: {
                status: "",
                order_info: {}, // 订单信息
                invoice_info: {}, // 开票信息
                other_info: {}, // 其它信息
            },
            formLoading: false,
            invoiceForm: {
                invoice_no: "",
                invoice_number: "",
                finance_remark: "",
                finance_attachments: [],
            },
            invoiceFormRules: {
                invoice_number: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "请输入发票号码",
                    },
                ],
            },
            btnDisabled: false,
            previewImgList: [],
            previewImgSrc: "",
        };
    },
    created() {
        if (this.invoice_no) {
            this.getInvoiceDetail();
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:invoiceConfirmationDialog", false);
        },
        // 详情
        getInvoiceDetail() {
            InvoiceDetail({ invoice_no: this.invoice_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.invoiceDetails = data;
                }
            });
        },
        handleClickUploadFile() {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            input.setAttribute("multiple", "multiple");
            input.click();
            const that = this;
            input.onchange = function () {
                const files = Array.from(this.files);
                if (files.some((file) => file.size > 5 * 1024 * 1024))
                    return that.$message.error("图片大小不允许超过5m");
                // if (that.invoiceForm.finance_attachments.length + files.length > 5)
                //     return that.$message.error("最多只能上传5张");
                files.forEach((file) => {
                    uploadImg(file)
                        .then((res) => {
                            that.invoiceForm.finance_attachments.push(res.file_path);
                        })
                        .catch(() => {
                            return false;
                        });
                });
            };
        },
        // 上传附件
        handleUploadFileChange(e) {
            const files = e.target.files;
            const that = this;
            Array.from(files).forEach((file) => {
                uploadImg(file, 50)
                    .then((res) => {
                        if (res.file_path) {
                            res.file_size = formatFileSize(file.size);
                            this.invoiceForm.finance_attachments.push(res);
                            this.$forceUpdate();
                            e.target.value = "";
                        }
                        e.target.value = "";
                    })
                    .catch((error) => {
                        e.target.value = "";
                    });
            });
        },
        // 预览
        handleClickPreview(file) {
            if (file.file_type.indexOf("image") > -1) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        // 提交
        handleDialogConfirm() {
            this.$refs.invoiceForm.validate((valid) => {
                if (valid) {
                    this.btnDisabled = true;
                    this.formLoading = true;
                    let params = {
                        invoice_no: this.invoice_no,
                        invoice_number: this.invoiceForm.invoice_number,
                        finance_remark: this.invoiceForm.finance_remark,
                        finance_attachments: this.invoiceForm.finance_attachments,
                    };
                    InvoiceConfirm(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.formLoading = false;
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.$emit("confirmSuccess");
                                        this.handleDialogClose();
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.formLoading = false;
                            }
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                            this.formLoading = false;
                        });
                }
            });
        },
        //查看订单详情
        handleClickOrderDetail() {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: this.invoiceDetails.order_info.order_no,
                    name: this.invoiceDetails.order_info.order_no,
                    query_type: "order_no",
                },
            });
        },
    },
};
</script>
<style lang="scss">
.custom_invoice_dialog {
    .el-dialog__body {
        max-height: 690px;
        overflow-y: auto;
    }

    .page_little_title {
        line-height: 22px;
        color: #333333;
        font-weight: 700;
        padding-left: 8px;
        position: relative;
        margin-bottom: 16px;

        &::before {
            width: 3px;
            height: 22px;
            border-radius: 2px;
            background: #409eff;
            content: "";
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .voucher_list {
        display: flex;
        gap: 8px;

        .upload_img_wrap {
            width: 48px;
            height: 48px;
            background: #edf0f4;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-icon-plus {
                color: #666666;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .voucher_item {
            width: 48px;
            height: 48px;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }

            .icon-jianqu {
                position: absolute;
                right: -8px;
                top: -8px;
                cursor: pointer;
                font-size: 16px;
                color: rgba(255, 77, 79, 1);
                line-height: 16px;
            }
        }

        &.voucher_detail_list {
            .voucher_item {
                border: none;
            }
        }
    }

    .el-form {
        .el-form-item__label {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
        }

        .text_bg {
            padding: 8px 12px;
            line-height: 22px;
            border-radius: 6px;
            background: rgba(237, 240, 244, 1);
        }

        .el-link {
            display: inline;
        }
    }

    .invoice_info_text {
        border: 1px solid rgba(217, 217, 217, 1);
        min-height: 156px;
        padding: 12px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }
    .el-form {
        .el-row {
            .el-link--primary {
                display: block;
            }
        }
    }
}
</style>
